import { forwardRef, useEffect, useState, useRef } from "react";
import { IconX, IconArrowForward } from '@tabler/icons-react';
import { InputDataItem } from '@/types';
import Tiptap from "../tiptap";
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';

interface InputItemProps {
    item: InputDataItem;
    onChange: (id: string, newValue: any) => void;
    handleToggle: (id: string) => void;
    onChangeLabel: (id: string, name: string, newValue: any) => void;
    onRemove: (id: string) => void;
    inputConfigMap: { [key: string]: React.FC<any> }; 
}

const InputItem = forwardRef<HTMLInputElement, InputItemProps>(({ item, onChange, onRemove, inputConfigMap, onChangeLabel, handleToggle }, ref) => {
    const Component = inputConfigMap[item.type] || inputConfigMap['Text Input'];


    const [editorContent, setEditorContent] = useState(item.inputText);

    useEffect(()=>{
        onChangeLabel(item.id, "inputText", editorContent )
    }, [editorContent])

    return (
        <div key={item.id} className="border border-blue-100 border-2 rounded-lg hover:border-blue-500 mt-2">
            <div className="border-b p-2">
                <div className="flex flex-row gap-2 items-center mb-2">
                    

                    <Input
                        type="text"
                        placeholder="Enter title for input..."
                        value={item.title}
                        className="font-bold text-lg py-1"
                        ref={ref}
                        name="title"
                        onChange={(e) => onChangeLabel(item.id, e.target.name, e.target.value)}
                        />

                    <span 
                      onClick={() => handleToggle(item.id)}
                    className="px-1.5 h-5 inline-flex items-center rounded-md transition-colors font-semibold text-[11px] bg-gray-200 text-gray-800 cursor-pointer">
                        {item.required ? 'required' : 'optional'}
                    </span>
                    <IconX
                        size={24}
                        className="cursor-pointer hover:bg-gray-200 hover:rounded-lg"
                        stroke={1}
                        onClick={() => onRemove(item.id)}
                    />
                </div>

                <Textarea
                    name="description"
                    placeholder="Enter description input..."
                    value={item.description}
                    onChange={(e) => onChangeLabel(item.id, e.target.name, e.target.value)}
                    rows={1}
                    />

            </div>
            <div className="border-b p-4 bg-gray-50">
                <Component item={item} onChange={(value: any) => onChange(item.id, value)}  />
            </div>
            <div className="p-1 flex items-center space-x-2">
                <IconArrowForward size={20} stroke={0.5} />
                <div className="flex items-center space-x-2 max-w-96">
                    <div style={{ display: 'inline-block', maxWidth: '24rem' }}>

                    <Tiptap editorContent={editorContent} setEditorContent={setEditorContent} className="focus:border-blue-600 focus:border-2 rounded-lg  focus:outline-none "/>

                    </div>
                    <span className="bg-gray-100/75 px-2 py-1 rounded-md text-xs font-semibold flex-grow text-gray-500">
                        {item.labelText}
                    </span>
                </div>
            </div>
        </div>
    );
});

export default InputItem;
